/**
 * RagsImage model
 */

import { EnhancedInputData, SetupEnhInputData } from './EnhancedInputData';

// Forward declaration
declare function GetImageMimeType(ext: string): string;

export class RagsImage {
    TheName: string = "";
    curfilename: string = "";
    GroupName: string = "";
    TheType: string = "";
    LayeredImages: string[] = [""];
    EnhInputData: EnhancedInputData = new EnhancedInputData();

    cloneForDiff(): { LayeredImages: any[] } {
        return {
            LayeredImages: this.LayeredImages.slice(),
        };
    }
}

export function SetupImageData(GameData: any[]): RagsImage {
    const TheImage = new RagsImage();

    TheImage.TheName = GameData[0];
    TheImage.GroupName = GameData[1];
    TheImage.LayeredImages = GameData[2];
    TheImage.EnhInputData = SetupEnhInputData(GameData[3]);
    const imagetype = (window as any).GetImageMimeType?.(TheImage.TheName.substr(TheImage.TheName.length - 3, 3)) || "";
    if (imagetype != "") {
        TheImage.TheType = imagetype;
    }
    return TheImage;
}
